// State
export const state = () => ({
	loading: false,
	banks: [],
	playerBanks: {}
})

// Actions
export const actions = {
	// Get all bank list
	async banks({ commit }, params) {
		commit('setBanks', [])
		try {
			commit('loading', true)
			await this.$axios
				.get(`/agents/bank-lists`, { params })
				.then((response) => {
					commit('setBanks', response.data.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async playerBanks({ commit }, params) {
		commit('playerBanks', [])
		try {
			commit('loading', true)
			await this.$axios
				.get(`/agents/bank-account`, { params })
				.then((response) => {
					commit('playerBanks', response.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async createBank({ commit }, form) {
		try {
			const id = form.id;
			delete form.id;
			const response = await this.$axios
				.post(`/agents-bank-account/${id}`, form)
				.then((response) => {
					return true
				})
			return response
		} catch (error) {
			return false;
		}
	},

}

// Mutations
export const mutations = {
	loading(state, type) {
		state.loading = type
	},
	setBanks(state, data) {
		state.banks = data
	},
	playerBanks(state, data) {
		state.playerBanks = data
	},
}

// Getters
export const getters = {}
